import PropTypes from 'prop-types';
import React from 'react';
import { findDOMNode } from 'react-dom';

class CheckboxGroupInput extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    values: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.number
      })
    ).isRequired,
    selectedValues: PropTypes.arrayOf(PropTypes.number).isRequired
  };

  static defaultProps = { selectedValues: [] };

  render() {
    return <div>{this.props.values.map(this._renderLabelCheckboxPair)}</div>;
  }

  _renderLabelCheckboxPair = value => {
    return (
      <label key={value.id} title={value.name}>
        <input
          type="checkbox"
          value={value.id}
          checked={this.props.selectedValues.indexOf(value.id) >= 0}
          onChange={this.props.onChange}
        />
        {value.name}
      </label>
    );
  };

  getSelectedValues = () => {
    const nodes = [].slice.call(
      findDOMNode(this).querySelectorAll('input[type="checkbox"]')
    );
    return nodes
      .filter(node => node.checked)
      .map(node => parseInt(node.value, 10));
  };
}

export default CheckboxGroupInput;
